module.exports = __webpack_public_path__ + "img/ongoing_compressed.a6407059.jpg";